import React from 'react'
import { IS_ARTIST } from '@disco/constants/FeatureTypes'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'
import LibrariesUpgradeAlert from 'components/libraries/libraries-upgrade-alert'
import Button from 'components/ui/button'
import Heading from 'components/ui/heading'
import Stack from 'components/ui/stack'
import Video from 'components/ui/video'
import styles from './index.module.css'

type Props = {
  clientLibrariesTrial?: boolean
  isLibrariesEmpty?: boolean
  onClick: (...args: Array<any>) => any
}

const LibrariesTrialBlank = ({
  clientLibrariesTrial,
  isLibrariesEmpty,
  onClick,
}: Props): React.ReactElement<'div'> => {
  const isArtist = useFeatureEnabled(IS_ARTIST)
  const title = isArtist
    ? 'Create a searchable Catalog'
    : 'Simple, beautiful, searchable Catalogs'
  const description = isArtist ? (
    <div className={styles.librariesTrialBlankDescription}>
      Catalogs are a searchable experience for collections of over 500 tracks.
      It’s most suitable for record labels, publishers, sync agencies, music
      collectives and composers with large collections of works. For artists
      sharing music, we recommend using Pages.
    </div>
  ) : (
    <div>
      Let clients search your music library and find what they need,when they
      need it.
    </div>
  )
  const button = isArtist ? (
    <Button
      appearance="primary"
      caption="Find out more"
      link="https://support.disco.ac/home/discovery-suite-guide"
      linkTarget="_blank"
    />
  ) : (
    <Button
      appearance="primary"
      caption="Try Catalogs free"
      onClick={onClick}
    />
  )
  return (
    <div className={styles.librariesTrialBlank}>
      <Stack space="xlarge">
        {!isLibrariesEmpty && !isArtist && (
          <LibrariesUpgradeAlert clientLibrariesTrial={clientLibrariesTrial} />
        )}
        <div className={styles.librariesTrialBlankVideo}>
          <Video
            src="https://www.youtube.com/embed/1pnXU5SuJhM"
            width={1280}
            height={720}
          />
        </div>
        <Stack space="small">
          <Stack space="xxsmall">
            <Heading size={700}>{title}</Heading>
            {description}
          </Stack>
          {button}
          {!isArtist && (
            <div className={styles.librariesTrialBlankNote}>
              <span>Want to know more?</span>{' '}
              <Button
                appearance="inline-link"
                caption="Check out our FAQ."
                compact
                link="https://support.disco.ac/home/discovery-suite-guide#faq"
                linkTarget="_blank"
              />
            </div>
          )}
        </Stack>
      </Stack>
    </div>
  )
}

export default LibrariesTrialBlank
